import config from "../../config";
import $ from "jquery";
import Sidebar from "../../components/partials/Sidebar";
import Header from "../../components/partials/Header";
import Breadcrumb from "../../components/Breadcrumb";
import { useEffect, useRef, useState } from "react";
import "./style.css";
import addIcon from "../../images/icons/add.png";
import deleteIcon from "../../images/icons/delete.png";
import moment from "moment";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  inputOnlyNumber,
  millionComma,
  removeMillionComma,
  userBackDate,
} from "../../utils";
import Swal from "sweetalert2";
import expenseSchema from "../../validations/expenseSchema";
import CommonAsyncSelect from "../../components/CommonAsyncSelect";
import { BiCreditCard } from "react-icons/bi";
import PayDtlCard from "../../components/PayDtlCard";

function ExpenseEdit(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const expense = location.state?.expense;
  let filter = location.state?.currentFilter;
  let currentFilterState = location.state?.showFilter;
  let page = location.state?.currentPageNo;
  const exp_dtl = {
    item_name: "",
    rate: "",
    qty: "",
    amount: "",
  };
  const payDtl = [
    { mode: "Cash UGX", conv: 1, conv_amt: "", amt: "" },
    { mode: "USD", conv: 1, conv_amt: "", amt: "" },
    { mode: "Momo Pay", conv: 1, conv_amt: "", amt: "" },
    { mode: "Airtel Money", conv: 1, conv_amt: "", amt: "" },
  ];
  const initialState = {
    branch_id: "",
    exp_cat_id: "",
    exp_type: "",
    narration: "",
    dt_of_exp: moment().format("YYYY-MM-DD"),
    exp_dtl: [exp_dtl],
    pay_dtl: payDtl,
  };

  const [formInputs, setFormInputs] = useState(initialState);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const totalRef = useRef(0);

  const [totalValue, setTotalValue] = useState("");
  useEffect(() => {
    const interval = setInterval(() => {
      if (totalRef.current) {
        setTotalValue(totalRef.current.value);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);
  const focus = useRef([{}]);

  function calculateTotal() {
    totalRef.current.value = 0;
    formInputs.exp_dtl.forEach((prod) => {
      totalRef.current.value = removeMillionComma(totalRef.current.value);

      let total = isNaN(parseFloat(totalRef.current.value))
        ? 0
        : parseFloat(totalRef.current.value);
      let total_amt = isNaN(parseFloat(prod.amount))
        ? 0
        : parseFloat(prod.amount);
      let amt = parseFloat(total + total_amt).toFixed(2);
      totalRef.current.value = millionComma(amt);
    });
  }

  function handleInputs(e) {
    setFormInputs((prevState) => {
      let newState = {
        ...prevState,
        [e.target.name]: e.target.value,
      };
      return newState;
    });
  }

  function handleTableInputs(e) {
    let idx = window.event.target.closest("tr").getAttribute("data-id");
    let expense = formInputs.exp_dtl[idx];

    let prodName =
      e.target.name == "item_name" ? e.target.value : expense.item_name;
    let basePrice = e.target.name == "rate" ? e.target.value : expense.rate;
    let qty = e.target.name == "qty" ? e.target.value : expense.qty;

    let grossAmt = parseFloat(parseFloat(basePrice) * parseFloat(qty)).toFixed(
      2,
    );
    let expDtl = {
      item_name: prodName,
      qty: qty,
      rate: basePrice,
      amount: isNaN(grossAmt) ? 0 : grossAmt,
    };
    let existExpDtl = formInputs.exp_dtl;
    existExpDtl[idx] = expDtl;
    setFormInputs((prevState) => {
      let newState = {
        ...prevState,
        exp_dtl: existExpDtl,
      };
      return newState;
    });
  }

  function handleItemCount(v, i) {
    if (v == "+") {
      if (formInputs.exp_dtl[formInputs.exp_dtl.length - 1].item_name == "") {
        Swal.fire({ html: "Please fill proper data." });
      } else {
        let existExpDtl = formInputs.exp_dtl;
        existExpDtl[formInputs.exp_dtl.length] = exp_dtl;
        setFormInputs({ ...formInputs, exp_dtl: existExpDtl });
      }
    } else if (v == "-") {
      if (formInputs.exp_dtl.length == 1) {
        Swal.fire({ html: "Can't delete last row." });
      } else {
        let existExpDtl = formInputs.exp_dtl.filter((v, idx) => {
          return idx != i;
        });
        setFormInputs({ ...formInputs, exp_dtl: existExpDtl });
      }
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    var grossamtval = parseFloat(totalRef.current.value.replace(/,/g, ""));
    if (grossamtval == 0) {
      if (formInputs.narration == "") {
        Swal.fire({ html: "Narration is Required" });
        return;
      }
    }

    let remainingAmount = grossamtval || 0;
    formInputs?.pay_dtl?.forEach((pay) => {
      if (pay.mode !== "Cash UGX") {
        remainingAmount -= parseFloat(pay.amt || 0);
      }
    });

    // const updatedPayments = formInputs?.pay_dtl?.map((pay) => {
    //   if (pay.mode === "Cash UGX") {
    //     let amount = parseFloat(remainingAmount) < 0 ? grossamtval : parseFloat(remainingAmount)
    //     return { ...pay, amt: amount || 0, conv_amt: amount || 0 };
    //   } else {
    //     return parseFloat(remainingAmount) < 0 ? { ...pay, amt: '', conv_amt: '' } : pay
    //   }
    // });
    const updatedPayments = formInputs?.pay_dtl?.map((pay) => {
      if (pay.mode === "Cash UGX") {
        let amount = parseFloat(remainingAmount);
        return { ...pay, amt: amount || 0, conv_amt: amount || 0 };
      } else {
        return pay;
      }
    });
    setFormInputs((prevState) => ({
      ...prevState,
      pay_dtl: updatedPayments,
    }));
    if (formInputs.exp_dtl.length > 1) {
      formInputs.exp_dtl = formInputs.exp_dtl.filter((p) => p.item_name != "");
    }
    let isInvalid = await expenseSchema.validateEdit(formInputs);
    if (isInvalid?.errors) {
      Swal.fire("", isInvalid.errors[0]);
      return;
    }

    formInputs.exp_hdr_id = id;
    formInputs.amount = removeMillionComma(totalRef.current.value);

    setIsSubmit(true);
    await $.post(
      `${config.apiUrl}/expense/editExpense`,
      JSON.stringify(formInputs),
    )
      .done(function (res) {
        Swal.fire({
          title: "Success",
          icon: "success",
          showConfirmButton: true,
          confirmButtonText: "Make New expense",
          showCancelButton: true,
          cancelButtonText: "Back to List",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
        }).then((event) => {
          if (event.isConfirmed) {
            navigate("/expense/add");
          } else if (event.isDismissed) {
            navigate("/expense");
          }
        });
        totalRef.current.value = 0;
        setFormInputs(initialState);
        setSelectedCategory("");
      })
      .catch(function (err) {
        Swal.fire({
          title: "Error",
          icon: "error",
          text: err?.responseJSON?.data?.message || err?.responseJSON?.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
      })
      .always(function () {
        setIsSubmit(false);
      });
  }

  useEffect(function () {
    setSelectedCategory({
      exp_cat_id: expense.exp_cat_id,
      exp_cat_name: expense.exp_cat_name,
    });

    setFormInputs((prevState) => {
      return {
        exp_cat_id: expense?.exp_cat_id,
        exp_type: expense?.exp_type,
        narration: expense?.narration,
        dt_of_exp: moment(expense?.dt_of_exp).format("YYYY-MM-DD"),
        amount: expense?.amount,
        exp_dtl: expense?.exp_dtl,
      };
    });
  }, []);

  useEffect(function () {
    focus.current[0].dt_of_exp.focus();
  }, []);

  useEffect(
    function () {
      calculateTotal();
    },
    [formInputs],
  );

  const [showPayDtl, setShowPayDtl] = useState(false);
  const handlePayDtl = () => {
    setShowPayDtl((prevState) => !prevState);
  };

  function getPaymentMode() {
    const paymentModes = formInputs.pay_dtl.filter(
      (pay) => pay.amt !== "" && pay.amt !== undefined && pay.amt > 0,
    );

    if (paymentModes.length === 0) {
      return "Cash UGX";
    } else if (paymentModes.length === 1) {
      return paymentModes[0].mode;
    } else {
      return "Multiple";
    }
  }
  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2 position-relative pb-8">
          <Header />
          <Breadcrumb path={["Expense", "Add Expense"]} />

          <main className="bg-white rounded-2" id="expenseAdd">
            <div className="container-fluid p-2 position-relative">
              <Link
                to="/expense"
                className="position-absolute text-decoration-none small"
                style={{ top: "-1.5rem", right: "0" }}
                state={{
                  backToCurrent: page,
                  appliedFilter: filter,
                  filterDisplay: currentFilterState,
                }}
              >
                Go Back to List
              </Link>
              <form autoComplete="off" className="row gx-4 gy-2">
                <div className="col-md-3">
                  <label htmlFor="dt_of_exp">
                    Expense Date <span className="text-danger">*</span>
                  </label>
                  <input
                    // min={moment().subtract(30, "days").format("YYYY-MM-DD")}
                    min={userBackDate()}
                    max={moment().format("YYYY-MM-DD")}
                    ref={(el) => (focus.current[0].dt_of_exp = el)}
                    type="date"
                    className="form-control"
                    name="dt_of_exp"
                    value={formInputs.dt_of_exp}
                    onChange={(e) => {
                      handleInputs(e);
                      focus.current[0].exp_type.focus();
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="exp_type">
                    Expense Type<span className="text-danger">*</span>{" "}
                  </label>
                  <select
                    ref={(el) => (focus.current[0].exp_type = el)}
                    className="form-select"
                    name="exp_type"
                    value={formInputs.exp_type}
                    onChange={(e) => {
                      handleInputs(e);
                      setSelectedCategory("");
                      setFormInputs((prevState) => {
                        let newState = {
                          ...prevState,
                          exp_cat_id: "",
                        };
                        return newState;
                      });
                      if ([1, 2].includes(Number(e.target.value))) {
                        setTimeout(() => {
                          focus.current[0].exp_cat_id?.focus();
                        }, 0);
                      } else {
                        setTimeout(() => {
                          focus.current[0].narration?.focus();
                        }, 0);
                      }
                    }}
                  >
                    <option value="" hidden>
                      Select...
                    </option>
                    {config.expenseCategories.map((list) => (
                      <option value={list.value}>{list.label}</option>
                    ))}
                  </select>
                </div>
                {[1, 2].includes(Number(formInputs?.exp_type)) ? (
                  <div className="col-md-3">
                    <label htmlFor="exp_cat_id">
                      Expense Category <span className="text-danger">*</span>
                    </label>
                    <CommonAsyncSelect
                      isDisabled={formInputs.exp_type == ""}
                      ref={(el) => (focus.current[0].exp_cat_id = el)}
                      getOptionLabel={(o) => o.exp_cat_name}
                      getOptionValue={(o) => o.exp_cat_id}
                      noOptionsMessage={() => null}
                      placeholder=""
                      loadOptions={async (inputValue, callback) => {
                        await $.post(
                          `${config.apiUrl}/expCategory/listExpCategory`,
                          JSON.stringify({
                            paginate: 0,
                            is_active: 1,
                            ...(formInputs.exp_type && {
                              exp_cat_type: formInputs.exp_type,
                            }),
                            exp_cat_name: inputValue,
                          }),
                          function (res) {
                            callback(res.data?.list || res.data || []);
                          },
                        );
                      }}
                      isClearable={true}
                      value={selectedCategory}
                      onChange={(e) => {
                        if (!e) {
                          setSelectedCategory(null);
                          setFormInputs({
                            ...formInputs,
                            exp_cat_id: "",
                          });
                          return;
                        }
                        Swal.fire({
                          title: "Are you sure?",
                          text: "You want to change the Expense Category?",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Yes, change it!",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            setSelectedCategory(e);
                            setFormInputs({
                              ...formInputs,
                              exp_cat_id: e.exp_cat_id,
                            });
                            focus.current[0].narration.focus();
                          }
                        });
                      }}
                      components={{
                        IndicatorsContainer: () => null,
                      }}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          minHeight: "0px",
                          height: "29px",
                        }),
                        valueContainer: (baseStyles, state) => ({
                          ...baseStyles,
                          paddingTop: "0px",
                          paddingBottom: "0px",
                          minHeight: "0px",
                          height: "29px",
                        }),
                        input: (baseStyles, state) => ({
                          ...baseStyles,
                          paddingTop: "0px",
                          paddingBottom: "0px",
                          marginTop: "0px",
                          marginBottom: "0px",
                          minHeight: "0px",
                          height: "29px",
                          fontSize: "12px",
                        }),
                        dropdownIndicator: (baseStyles, state) => ({
                          ...baseStyles,
                          paddingTop: "0px",
                          paddingBottom: "0px",
                        }),
                        option: (baseStyles, state) => ({
                          ...baseStyles,
                          paddingTop: "0px",
                          paddingBottom: "0px",
                        }),
                      }}
                      classNamePrefix="react-select"
                      tabSelectsValue
                    />
                  </div>
                ) : null}
                <div className="col-md-3">
                  <label htmlFor="narration">Narration</label>
                  <input
                    ref={(el) => (focus.current[0].narration = el)}
                    type="text"
                    className="form-control"
                    name="narration"
                    value={formInputs.narration}
                    onChange={handleInputs}
                  />
                </div>
                <div className="col-12">
                  <table
                    className="table mt-3 rounded"
                    cellPadding="0"
                    cellSpacing="0"
                  >
                    <thead>
                      <tr>
                        <th>
                          Item Name <span className="text-danger">*</span>
                        </th>
                        <th>
                          Qty <span className="text-danger">*</span>
                        </th>
                        <th>
                          Rate <span className="text-danger">*</span>
                        </th>
                        <th>Amount</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {formInputs.exp_dtl &&
                        formInputs.exp_dtl.map((v, i) => (
                          <tr key={i} data-id={i}>
                            <td className="w-25">
                              <input
                                type="text"
                                className="form-control"
                                name="item_name"
                                value={v.item_name}
                                onChange={handleTableInputs}
                                required
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control text-end"
                                name="qty"
                                value={v.qty}
                                onKeyDown={inputOnlyNumber}
                                onChange={handleTableInputs}
                                required
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control text-end"
                                name="rate"
                                value={millionComma(v?.rate)}
                                onChange={handleTableInputs}
                                onKeyDown={(e) => {
                                  if (e.key == "Enter") {
                                    e.preventDefault();
                                    handleItemCount("+", i);
                                  } else {
                                    inputOnlyNumber(e);
                                  }
                                }}
                                required
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control text-end"
                                name="amount"
                                value={millionComma(v?.amount)}
                                disabled
                              />
                            </td>
                            <td
                              style={{
                                width: "80px",
                                verticalAlign: "middle",
                              }}
                            >
                              <img
                                src={addIcon}
                                className="img-fluid m-1"
                                alt=""
                                onClick={() => handleItemCount("+", i)}
                                role="button"
                              />
                              <img
                                src={deleteIcon}
                                className="img-fluid m-1"
                                alt=""
                                onClick={() => handleItemCount("-", i)}
                                role="button"
                              />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <div className="col-12 mt-2">
                  {(error || success) && (
                    <div
                      className={`alert alert-${
                        error ? "danger" : "success"
                      } py-2 small`}
                      role="alert"
                    >
                      {error || success || ""}
                    </div>
                  )}
                </div>
              </form>
            </div>

            <div className="container-fluid mt-5">
              <div className="row">
                <div className="col-12 position-absolute bottom-0 start-0 end-0">
                  <div
                    className="row rounded px-2 py-3"
                    style={{ background: "#F4F7FE" }}
                  >
                    <div className="col-md-3">
                      <label htmlFor="totalRef">Gross Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="totalRef"
                        ref={totalRef}
                        disabled
                      />
                    </div>
                    <div className="col d-flex mt-auto justify-content-end">
                      <div
                        style={{
                          border: "1px solid gray",
                          height: "37px",
                          minWidth: "200px",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <b className="me-2">{getPaymentMode()} </b> :{" "}
                        {totalValue}
                      </div>
                      <button
                        onClick={handlePayDtl}
                        className="text-primary mt-1 me-4 border border-0 bg-transparent"
                      >
                        <BiCreditCard size={32} role="button" />
                      </button>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        onClick={handleSubmit}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      {showPayDtl && (
        <PayDtlCard
          cardMode="edit"
          showPayDtl={showPayDtl}
          handlePayDtl={handlePayDtl}
          formInputs={formInputs}
          setFormInputs={setFormInputs}
          grossTotal={removeMillionComma(totalRef.current.value)}
        />
      )}
    </>
  );
}

export default ExpenseEdit;
